import store from "store";
import { SET_CURRENT_PROJECT } from "../constans";

export const setCurrentProjectAction = (payload) => ({
  type: SET_CURRENT_PROJECT,
  payload: payload,
});


export const getProjectIdAction = () => {
  const model = store.getState().currentProject.project.id
  const projectUrl = model.split("/projects/")[1]
  const projectId = projectUrl ? projectUrl.split("/")[0] : null;
  return projectId;
};



